<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <InactiveMemberReportTable/>
      </b-col>
    </b-row>
  </div>

</template>

<script>
  import InactiveMemberReportTable from './InactiveMemberReportTable.vue'

  export default {
    name: 'inactivememberreport-table',
    components: { InactiveMemberReportTable }
  }
</script>



// WEBPACK FOOTER //
// src/views/report/member/InactiveMemberReport.vue